// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__28-Sx","empty":"ModalGraph_empty__M6Yqn"};